var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChartAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pie-chart-alt",
    clipPath: "url(#clip0_804_69638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8562 0.506226C10.5187 0.506226 10.2094 0.787476 10.2094 1.1531V6.7781C10.2094 7.1156 10.4906 7.42498 10.8562 7.42498H16.875C17.0437 7.42498 17.2125 7.3406 17.325 7.2281C17.4375 7.08748 17.4937 6.91873 17.4937 6.74998C17.2687 3.23435 14.3437 0.506226 10.8562 0.506226ZM11.475 6.1031V1.79998C13.8093 2.08123 15.6937 3.82498 16.1437 6.13123H11.475V6.1031Z",
    fill: "#DEE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.3844 8.69057H9.11248V2.6437C9.11248 2.3062 8.83123 2.02495 8.49373 2.02495C8.40935 2.02495 8.32498 2.02495 8.2406 2.02495C3.9656 1.99682 0.506226 5.48432 0.506226 9.75932C0.506226 14.0343 3.99373 17.5218 8.26873 17.5218C12.5437 17.5218 16.0312 14.0343 16.0312 9.75932C16.0312 9.59057 16.0312 9.42182 16.0031 9.2812C16.0031 8.9437 15.7219 8.69057 15.3844 8.69057ZM8.26873 16.2562C4.66873 16.2562 1.77185 13.3593 1.77185 9.75932C1.77185 6.32807 4.47185 3.48745 7.87498 3.29057V9.30932C7.87498 9.64682 8.15623 9.9562 8.52185 9.9562H14.7937C14.6812 13.4437 11.7844 16.2562 8.26873 16.2562Z",
    fill: "#DEE4EE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_804_69638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChartAlt);
export default __webpack_public_path__ + "static/media/pie-chart-alt.115ff989a3d6d167ccc762216a3de9e2.svg";
export { ForwardRef as ReactComponent };